import React from 'react';
import { Grid, List, ListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { useAppSelector } from '../../../redux/hooks';
import { RoundedSkeleton } from '../../ClientTable/LoadingSkeleton';

function WhatAIThinks({ whatAiThinks }: { whatAiThinks: string[] }) {
  const { t } = useTranslation();
  const clientActivityProgressLoading = useAppSelector(
    (state) => state.client.clientActivityProgressLoading
  );

  return (
    <Grid display="flex" flexDirection="column" gap="12px">
      <Grid display="flex" flexDirection="column" gap="12px">
        {clientActivityProgressLoading ? (
          <>
            <RoundedSkeleton variant="rounded" width={141} height={17.5} />
            <RoundedSkeleton variant="rounded" width="100%" height={14.875} />
          </>
        ) : (
          <>
            <Typography variant="h6" color="primary">
              {t('clientProgress.whatAiThinks')}
            </Typography>
            {whatAiThinks !== null ? (
              <Typography variant="bodyRegular" color="primary">
                {t('clientProgress.aiMayWrong')}
              </Typography>
            ) : (
              <Typography variant="bodyRegular" color="primary">
                {t('clientProgress.emptyWhatAiThinks')}
              </Typography>
            )}
          </>
        )}
      </Grid>
      <Grid>
        {clientActivityProgressLoading ? (
          <Grid display="flex" flexDirection="column" gap="20px" mt={4}>
            {[...Array(7)].map((_count) => (
              <RoundedSkeleton key={uuidv4()} variant="rounded" width="100%" height={14.875} />
            ))}
          </Grid>
        ) : (
          <List
            sx={{
              listStyleType: 'circle',
              paddingInlineStart: '20px',
              '& .MuiListItem-root': {
                display: 'list-item',
                mt: '12px',
              },
            }}
          >
            {whatAiThinks?.map((item) => (
              <ListItem
                component="li"
                key={item}
                style={{
                  listStyleType: 'disc',
                  paddingInlineStart: '0px',
                  padding: '0px',
                }}
              >
                <Typography color="primary" variant="bodyRegular">
                  {item}
                </Typography>
              </ListItem>
            ))}
          </List>
        )}
      </Grid>
    </Grid>
  );
}

export default WhatAIThinks;
